export default __webpack_public_path__ + "static/media/Primarylogomark_purple_black_white-03.e795b109.png";